/**
 * RecommendationText — renders AI recommendation text with markdown support.
 *
 * Handles bullet-pointed action items (e.g. "- Review PO\n- Reply to customer")
 * by rendering them as proper HTML lists via ReactMarkdown.
 *
 * Falls back to plain text rendering when the content has no markdown formatting.
 */

import ReactMarkdown from 'react-markdown';
import styles from './RecommendationText.module.css';

interface RecommendationTextProps {
  /** The recommendation text, potentially containing markdown bullet lists. */
  text: string;
  /** Optional extra CSS class applied to the wrapper div. */
  className?: string;
}

const RecommendationText: React.FC<RecommendationTextProps> = ({ text, className }) => {
  return (
    <div className={`${styles.wrapper} ${className ?? ''}`}>
      <ReactMarkdown
        components={{
          // Strip wrapping <p> tags to keep the layout compact
          p: ({ children }) => <span className={styles.paragraph}>{children}</span>,
          ul: ({ children }) => <ul className={styles.bulletList}>{children}</ul>,
          li: ({ children }) => <li className={styles.bulletItem}>{children}</li>,
        }}
      >
        {text}
      </ReactMarkdown>
    </div>
  );
};

export default RecommendationText;
